import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './lib/auth.js';
import { AppSidebar } from './components/AppSidebar.js';
import { TopBar } from './components/TopBar.js';
import { LoginPage } from './pages/LoginPage.js';
import { LoginErrorPage } from './pages/LoginErrorPage.js';
import { FloorPage } from './pages/FloorPage.js';
import { TableHomePage } from './pages/TableHomePage.js';
import { TableListPage } from './pages/TableListPage.js';
import { AdminPage } from './pages/AdminPage.js';
import { SettingsPage } from './pages/SettingsPage.js';

export function App() {
  const { user, loading, error } = useAuth();

  if (loading) {
    return <div className="flex h-full items-center justify-center text-slate-400">Loading…</div>;
  }

  if (error) {
    return (
      <div className="flex h-full items-center justify-center px-6 text-center text-slate-300">
        <div>
          <p className="mb-2 text-lg font-medium">Something went wrong</p>
          <p className="text-sm text-slate-400">{error.message}</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/login/error" element={<LoginErrorPage />} />

      <Route
        path="*"
        element={
          user ? (
            <div className="flex h-full">
              <AppSidebar />
              <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
                <TopBar />
                <main className="flex-1 overflow-hidden">
                  <Routes>
                    <Route path="/" element={<FloorPage />} />
                    <Route path="/tables" element={<TableListPage />} />
                    <Route path="/tables/:id" element={<TableHomePage />} />
                    <Route path="/admin/*" element={<AdminPage />} />
                    <Route path="/settings" element={<SettingsPage />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </main>
              </div>
            </div>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
    </Routes>
  );
}
